import { withStyles, MenuItem } from "@material-ui/core";

const styles = (theme) => ({
  menuItem: {
    minWidth: 175,
    height: "auto",
    display: "flex",
    flexDirection: "column",
    padding: "4px 8px",
    color : theme.TextColor,
    backgroundColor: theme.ModalBGColor,
    "&$selected, &$selected:hover, &$selected:focus": {
      backgroundColor: theme.HeaderSelectedText,
      color: theme.white,
    },
  },
  selected: {},
  rowContainer: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: 10,
    width: "100%",
    marginBottom: -4,
  },
  city: {
    fontSize: 12,
    fontWeight: 600,
  },
});
const LocationDropdownItem = ({ props, classes }) => {
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused }
      component="div"
      classes={{
        root: classes.menuItem,
        selected: classes.selected,
      }}
      {...props.innerProps}
    >
      <div className={classes.rowContainer}>
        <span className={classes.city}>{props.data.city}</span>
        <span>{props.data.zip}</span>
      </div>
      <div className={classes.rowContainer}>
        <span>Term: {props.data.terminalCode ?? ""}</span>
        <span>
          State: {props.data.state} {`(${props.data.country})`}
        </span>
      </div>
    </MenuItem>
  );
};

export default withStyles(styles)(LocationDropdownItem);
